import { Tooltip } from "@mantine/core";
import { InfoCircledIcon } from "@modulz/radix-icons";
import styled from "styled-components";
import Histogram from "./charts/Histogram";
import { Paragraph, ParagraphBold } from "./styled";

const Wrapper = styled.div`
  height: 92px;
  width: 100%;
  background: var(--accentBg);
  border-radius: 8px;
  padding: 0 24px;
  display: flex;
  justify-content: center;
  flex-direction: column;
  margin-bottom: 16px;
`;

const BottomSection = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-top: 10px;
`;

const HistogramContainer = styled.div`
  display: flex;
  width: 100px;
  height: 24px;
`;

interface ICurrencySummaryCardProps {
	title: string;
	amount?: string;
	toolTip?: string;
	disabled?: boolean;
	hideHistogram?: boolean;
}
const histogramValues = [0, 0, 4, 7, 0, 1, 5];

export const CurrencySummaryCard = ({
	title,
	amount,
	disabled,
	toolTip,
	hideHistogram = false,
}: ICurrencySummaryCardProps): JSX.Element => {
	return (
		<Wrapper>
			{toolTip ? (
				<Tooltip
					label={toolTip}
					width={280}
					withArrow
					wrapLines
					styles={{
						body: {
							fontFamily: "ProximaNova",
							fontSize: 16,
							lineHeight: "22px",
							padding: 16,
              backgroundColor: "var(--accentBg)",
              color: "var(--textColor)",
						},
            arrow: {
              display: "none"
            },
            
					}}
				>
					<ToolTipInfo>
						<CardTitle className={disabled ? "disabled" : ""}>
							{title}
						</CardTitle>
						<InfoCircledIcon color="#8499B1" style={{ marginLeft: 12 }} />
					</ToolTipInfo>
				</Tooltip>
			) : (
				<CardTitle className={disabled ? "disabled" : ""}>{title}</CardTitle>
			)}
			<BottomSection>
				<CardAmount className={disabled ? "disabled" : ""}>{amount}</CardAmount>
				{!hideHistogram && (
					<HistogramContainer>
						<Histogram values={histogramValues} />
					</HistogramContainer>
				)}
			</BottomSection>
		</Wrapper>
	);
};

const ToolTipInfo = styled.div`
  display: flex;
  align-items: center;
  cursor: pointer;
`;

const CardTitle = styled(ParagraphBold)`
  color: var(--textColor);

  &.disabled {
    color: ${({ theme }) => theme.colors.secondary.grey};
  }
`;

const CardAmount = styled(Paragraph)`
  color: var(--textColor);
  font-size: 24px;
  font-family: 'ProximaNovaExtraBold', sans-serif;

  &.disabled {
    color: ${({ theme }) => theme.colors.secondary.grey};
  }
`;
